import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Pageheader } from './global-components/page-header';
import PropertySection from './section-components/property-section';
import bgImage from '../assets/img/bg/agricultural.webp';
import AgriculturalFilter from './common/AgriculturalFilter';

const AgriculturalPage = () => {
    const location = useLocation();
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [filters, setFilters] = useState({
        type: 'agricultural',
        keyword: '',
        area: '',
        acres: ''
    });

    // Handle incoming filters from navigation
    useEffect(() => {
        if (location.state?.filters && location.state?.fromSearch) {
            const incomingFilters = location.state.filters;
            const mappedFilters = {
                ...incomingFilters,
                type: 'agricultural', // Ensure type stays agricultural for this page
                // Map size fields appropriately
                acres: incomingFilters.acres || incomingFilters.size || incomingFilters.sqYards || ''
            };

            setFilters(mappedFilters);

            // If there are actual search criteria, trigger search mode
            const hasSearchCriteria = incomingFilters.keyword ||
                incomingFilters.area ||
                incomingFilters.acres ||
                incomingFilters.size ||
                incomingFilters.sqYards;

            if (hasSearchCriteria) {
                setIsSearchMode(true);
            }
        }
    }, [location.state]);

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        // Don't set search mode for filter changes - only for explicit search
    };

    const handleSearch = (searchFilters, isSearch = false) => {
        console.log('Searching with filters:', searchFilters);
        console.log('isSearch flag:', isSearch);
        setFilters(searchFilters);
        if (isSearch) {
            console.log('Setting search mode to true');
            setIsSearchMode(true); // Set search mode when search is triggered
            // Reset search mode after a brief delay to allow the effect to trigger
            setTimeout(() => {
                setIsSearchMode(false);
            }, 100);
        }
    };

    return (
        <div>
            <Pageheader headertitle="Agricultural Lands" bgImage={bgImage} />
            <AgriculturalFilter
                filters={filters}
                onFilterChange={handleFilterChange}
                onSearch={handleSearch}
            />
            <PropertySection
                type="agricultural"
                title="Looking for agricultural lands for sale in Amaravati?"
                description="Royale Spaces brings you prime agricultural lands in and around Amaravati. Perfect for farming, investment, or future development, our agricultural properties offer excellent soil quality, water access, and strategic locations near upcoming infrastructure. All lands come with verified documentation, clear titles, and transparent pricing, making your investment secure and profitable."
                filters={filters}
                isSearchMode={isSearchMode}
                initialPropertiesPerPage={6}
            />
        </div>
    );
};

export default AgriculturalPage;
